import { combineReducers } from 'core/redux'

import contacts from './contacts'

export default combineReducers({
  contacts,
})
